/**
 * Centralised, validated access to environment configuration.
 *
 * CRA only exposes variables prefixed with `REACT_APP_` and inlines them into
 * the client bundle at build time — so NEVER put real secrets (API keys,
 * tokens) here; everything below is non-sensitive public configuration.
 * Keeping all reads in one place means components never touch `process.env`
 * directly and we have a single spot for defaults/validation.
 */
const env = {
  graphqlHttpUrl:
    process.env.REACT_APP_GRAPHQL_HTTP_URL || 'http://localhost:4000/graphql',
  graphqlWsUrl: process.env.REACT_APP_GRAPHQL_WS_URL || 'ws://localhost:4000/graphql',
  defaultLanguage: process.env.REACT_APP_DEFAULT_LANGUAGE || 'en',

  appEnv: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development',
  isProduction: process.env.NODE_ENV === 'production',

  /** Optional brand logo URL (e.g. "/logo.svg" served from public/). Empty => icon fallback. */
  logoUrl: process.env.REACT_APP_LOGO_URL || '',

  /** Public legal / policy links shown in the app footer. */
  legal: {
    privacyPolicy: process.env.REACT_APP_PRIVACY_POLICY_URL || '',
    termsOfService: process.env.REACT_APP_TERMS_OF_SERVICE_URL || '',
    cancellationPolicy: process.env.REACT_APP_CANCELLATION_POLICY_URL || '',
    vendorTerms: process.env.REACT_APP_VENDOR_TERMS_OF_SERVICE_URL || '',
  },
};

export default env;
